import { useState } from "react";
import AppModal from "./AppModal";

/** const [ask, dialog] = useConfirm(); ask("Delete X?", () => doIt(), { label: "Delete" }); render {dialog}. */
export default function useConfirm() {
  const [state, setState] = useState(null);
  const ask = (text, run, { label = "Confirm", danger = true } = {}) => setState({ text, run, label, danger });
  const dialog = state ? (
    <AppModal title="Please confirm" onClose={() => setState(null)}>
      <p>{state.text}</p>
      <div className="d-flex justify-content-end gap-2">
        <button type="button" className="btn btn-outline-secondary" onClick={() => setState(null)}>Cancel</button>
        <button
          type="button"
          className={`btn ${state.danger ? "btn-danger" : "btn-primary"}`}
          onClick={() => {
            const { run } = state;
            setState(null);
            run();
          }}
        >
          {state.label}
        </button>
      </div>
    </AppModal>
  ) : null;
  return [ask, dialog];
}
